var _rect, _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6629_133355",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.66699H22.3313V20.2323H10V8.66699Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6629_133355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1647 9.66699C13.8347 9.66699 12.2107 11.4923 12.2107 13.1303C12.2107 14.5163 11.826 15.157 11.486 15.7223C11.2133 16.1763 10.998 16.535 10.998 17.3143C11.1093 18.5717 11.9393 19.2323 16.1647 19.2323C20.3667 19.2323 21.2227 18.5423 21.3333 17.271C21.3313 16.535 21.116 16.1763 20.8433 15.7223C20.5033 15.157 20.1187 14.5163 20.1187 13.1303C20.1187 11.4923 18.4947 9.66699 16.1647 9.66699M16.1647 20.2323C13.0473 20.2323 10.23 20.0123 10 17.357C9.99801 16.2583 10.3333 15.6997 10.6293 15.2077C10.9287 14.709 11.2107 14.239 11.2107 13.1303C11.2107 10.975 13.2013 8.66699 16.1647 8.66699C19.128 8.66699 21.1187 10.975 21.1187 13.1303C21.1187 14.239 21.4007 14.709 21.7 15.2077C21.996 15.6997 22.3313 16.2583 22.3313 17.3143C22.0987 20.0123 19.282 20.2323 16.1647 20.2323",
    fill: "#23273B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1317 23.0004H16.1304C15.383 22.9997 14.6757 22.6704 14.139 22.0724C13.9544 21.8677 13.971 21.5511 14.1764 21.3671C14.3817 21.1817 14.6977 21.1984 14.8824 21.4044C15.2277 21.7891 15.671 22.0004 16.131 22.0004H16.1317C16.5937 22.0004 17.039 21.7891 17.385 21.4037C17.5704 21.1991 17.8864 21.1824 18.091 21.3671C18.2964 21.5517 18.313 21.8684 18.1284 22.0731C17.5897 22.6711 16.881 23.0004 16.1317 23.0004",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventNotification);
export default __webpack_public_path__ + "static/media/eventNotification.17039a7cd935bb67f4cc1f1fed369fb2.svg";
export { ForwardRef as ReactComponent };